import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const WarningRoot = styled.div`
	display: flex;
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	padding: 12px 16px;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	text-align: center;
	font-size: 11px;
	font-weight: 400;
	line-height: 1.5;
	letter-spacing: 0.2px;

	@media (min-width: 768px) {
		padding: 12px 24px;
		font-size: 12px;
		line-height: 1.6;
		text-align: left;
	}
`;
